import ArtistList from "./index";

export const artistRoutes = () => [
  {
    path: "/admin/users/artist",
    component: ArtistList,
    layout: "admin",
    routeType: "admin",
    title: "Artist Management",
  },
];
